import {skeletonStoreSelectors} from "../../store";
import {homeStoreSelectors} from "../../modules/home/store/store";
import permissionsJson from "../../jsons/permissions.json";

export const checkForRouteAvailability = route => {
    return skeletonStoreSelectors.apiRoutes().hasOwnProperty(route);
};

export const checkPermission = permission => {
    const section = permissionSection(permission)
    let permissionsUser = userPermissions()

    return hasPermission(section, permissionsUser) || isAdmin()
};

export function hasPermission (section, permissionsUser) {
    let hasPermissions = true
    section.routes.map(route => {
        const permissionUser = permissionsUser.find(p => p.id === route.id)
        if (permissionUser) {
            route.access.map(acc => {
                if(!permissionUser.access.includes(acc)){
                    hasPermissions = false
                }
            })
        } else hasPermissions = false
        if(hasPermissions){
            section.link.map(link => {
                const sectionLink = permissionSection(link)
                let p = hasPermission(sectionLink, permissionsUser)
                if(!p) hasPermissions = false
            })
        }
    })
    return hasPermissions
}

export const permissionSection = (permission) => {
    let section
    permissionsJson.map(p => {
        const action = p.actions.find(action => action.key === permission)
        if (action) section = action
    })
    return section
}

export const userPermissions = () => {
    let userPermissions = []
    if (homeStoreSelectors.userInfo()) {
        homeStoreSelectors.userInfo().roles.map(role => {
                role['access'].map(access => {
                    const index = userPermissions.findIndex(p => p.id === access.resource_entity.id)
                    if (index === -1) {
                        userPermissions.push({
                            id: access.resource_entity.id,
                            name: access.resource_entity.name,
                            access: Object.keys(access.access).map(a => {
                                if (access.access[a].allow) return access.access[a].val
                            }).filter(a => a)
                        })
                    } else {
                        let acc = Object.keys(access.access).map(a => {
                            if (access.access[a].allow) return access.access[a].val
                        }).filter(a => a)
                        userPermissions[index].access = userPermissions[index].access.concat(acc)
                    }
                })
            }
        )
    }
    return userPermissions
}

export const isAdmin = () => {
    return homeStoreSelectors.userInfo()
        ? homeStoreSelectors.userInfo().roles.includes("Admin") ||
        homeStoreSelectors.userInfo().is_superuser
        : false;
};

export const hasAnyResourceAccess = (
    resourceName: string,
    accesses: string[],
    permissionsUser = userPermissions()
) => {
    const resource = permissionsUser.find(
        permission => permission.name === resourceName
    );

    return !!resource && accesses.some(access => resource.access.includes(access));
};

export const checkAnyResourceAccess = (
    resourceName: string,
    accesses: string[]
) => isAdmin() || hasAnyResourceAccess(resourceName, accesses);

export const canManageRTPProfiles = () =>
    checkAnyResourceAccess("rtp_profile", ["0b10", "0b100"]);

export const canAddGameCategories = () =>
    checkAnyResourceAccess("game_category", ["0b10"]);

export const canUpdateGameCategories = () =>
    checkAnyResourceAccess("game_category", ["0b100"]);

export const canDeleteGameCategories = () =>
    checkAnyResourceAccess("game_category", ["0b1000"]);

export const isSuperUser = () => {
    return homeStoreSelectors.userInfo()
        ? homeStoreSelectors.userInfo().is_superuser
        : false;
};

export const checkAuthorization = ({
                                       service,
                                       route
                                   }: {
    service?;
    route?;
}) => {
    let userAuthorization = false;
    if (route) {
        userAuthorization = checkForRouteAvailability(route);
    }
    if (service) {
        userAuthorization =
            skeletonStoreSelectors.reducedRoutes().indexOf(service) > -1
                ? true
                : false;
    }

    return true;
};

export const checkRouteServiceName = route => {
    const foundRoute = skeletonStoreSelectors.apiRoutes()[route];
    if (foundRoute) {
        return foundRoute.extra.service;
    }

    return null;
};
